import { Directive } from '@angular/core';
import { ShowOnEnterDirective } from './show-on-enter.directive';

@Directive({
  selector: '[showin]',
  standalone: true,
})
export class ShowinDirective extends ShowOnEnterDirective {
  protected override readonly direction = null;
}
